import { render, staticRenderFns } from "./CardBox.vue?vue&type=template&id=336cf44a&scoped=true&"
import script from "./CardBox.vue?vue&type=script&lang=js&"
export * from "./CardBox.vue?vue&type=script&lang=js&"
import style0 from "./CardBox.vue?vue&type=style&index=0&id=336cf44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336cf44a",
  null
  
)

export default component.exports